import React, {Component} from 'react';
import TableFilter from '../TableFilter'
import UtentiTable from './UtentiTable'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import {createInstance} from '../../Helpers';
import PropTypes from 'prop-types';
import UtentiStatoSelect from './UtentiStatoSelect'
import Moment from 'moment';

class UtentiList extends Component {

    constructor(props) {
        super(props);
        this.rowperpage = 20;//client.getDefaultRowsPerPage();
        this.state = this.getDefaultState();

        this.storeInstance = createInstance();

        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.onChangeUtentiStato = this.onChangeUtentiStato.bind(this)
        this.loadData = this.loadData.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
        this.onResettaFiltri = this.onResettaFiltri.bind(this)
        this.onDeleteUtente = this.onDeleteUtente.bind(this)
    }

    getDefaultState(){
        return {
            items: [],
            total: 0,
            page: 1,
            orderInfo: {},
            filterInfo: {
                keyword: '',
                attivo: true,
            },
            _loading: false,
            error: null,
            listViewType: 'l',
        };
    }

    getFilterDescription() {
        let msg = '';
        if (this.state.filterInfo.keyword !== undefined && this.state.filterInfo.keyword !== ''){
            msg += 'Username o nome contenente: ' + this.state.filterInfo.keyword;
        }
        if (this.state.filterInfo.attivo == false){
            msg += ' Utenti non attivi';
        }
        return  msg.trim();
    }

    onResettaFiltri(){
        this.setState(
            this.getDefaultState(),
            () => {this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);;}
        );
    }

    onChangeUtentiStato(attivo){
        let newFilterInfo = {
            keyword: this.state.filterInfo.keyword,
            attivo
        };
        this.loadData(1, this.state.orderInfo, newFilterInfo);
    }


    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('utentilist', this, () => {
            // Stato reimpostato. Ricarica i dati
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        })) {
        } else {
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }
    }

    componentWillUnmount() {
        if (this.storeInstance) {
            this.storeInstance.save('utentilist', this.state);
        }
    }

    onChangePage(newpage) {
        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onChangeColumnOrder(columnName, direction, data) {
        if (columnName){
            let newOrderInfo = {
                columnName: columnName,
                direction: direction,
                data: data
            };
            this.loadData(1, newOrderInfo, this.state.filterInfo)
        }
        else{
            this.loadData(1, {}, this.state.filterInfo);
        }
    }
    onChangeFilter(data){
        let newFilterInfo = this.state.filterInfo;
        newFilterInfo.keyword = data.keyword;
        this.loadData(1, this.state.orderInfo, newFilterInfo)
    }

    loadData(page, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadUtentiList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo,
            client.getCurrentUserId()
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    onDeleteUtente(ev, utente){

        this.setState({_loading: true});
        client.deleteUtente(utente).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo)
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui three column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Utenti soddisfano i filtri specificati
                    </div>
                    <div className="column">
                        <div className="ui ">
                            <button className="ui  button" onClick={() => this.onResettaFiltri()}>
                                <i className="delete icon"></i>Reimposta i filtri</button>
                        </div>
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">

                        </div>
                    </div>
                </div>


            </h3>
            <div className="ui attached segment">
                <div className="ui two column stackable grid">
                    <div className="Fourteen wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.keyword}
                            placeholder="Filtra per username o nome"
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                    <div className="two wide column">
                        <UtentiStatoSelect
                            isVisibile={this.state.filterInfo.attivo}
                            onChange={this.onChangeUtentiStato}
                        />          
                    </div>
                </div>
            </div>

            <UtentiTable
                items={this.state.items}
                count={this.state.total}
                page={this.state.page}
                rowperpage={this.rowperpage}
                tableOrderingField={this.state.orderInfo.columnName}
                tableOrderingDirection={this.state.orderInfo.direction}
                onChangePage={this.onChangePage}
                onChangeOrder={this.onChangeColumnOrder}
                onDeleteItem={this.onDeleteUtente}
                filterDescription={this.getFilterDescription()}
                readOnly={client.getCurrentUser().isadmin==false}
            />
            {loader}
        </div>)
    }
}

UtentiList.contextTypes = {
    router: PropTypes.object
}


export default UtentiList;




/** WEBPACK FOOTER **
 ** ./src/components/utenti/UtentiList.js
 **/